<template>
  <div class="baicaihuibottom">
    <ul class="baicaihuibottomul">
      <li class="baicaihuibottomulleft">
        <img src="../assets/images/bottomlog.png" alt="百才汇" />
        <p class="p1">免费咨询热线：400-800-8772</p>
        <p class="p2">总部地址：上海人才大厦22楼2208室（梅园路77号）</p>
      </li>
      <li class="baicaihuibottomulrigt">
        <img src="../assets/images/bottom_erweima.png" alt="百才汇" />
        <p>微信公众号上海落户通</p>
      </li>
    </ul>
    <div class="baicaihuibottom_bottom">
      <p>
        韩腾教育 版权所有 I ICP许可证：沪A2-20190160 I 京ICP备16010618号-2 I
        沪公网安备11010502039453号 Copyright © 2014-2020iyion.com.All Rights
        Reserved
      </p>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mouted() {},
  methods: {},
};
</script>

<style lang="scss" scoped>
.baicaihuibottom {
  width: 100%;
  background: #222222;
  margin: 0 auto;
  .baicaihuibottomul {
    padding: 40px;
    width: 100%;
    background: #333333;
    display: flex;
    .baicaihuibottomulleft {
      width: 420px;
      img {
        width: 200px;
        height: 54px;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 1px;
      }
      .p1 {
        margin-top: 20px;
      }
      .p2 {
        margin-top: 22px;
      }
    }
    .baicaihuibottomulrigt {
      width: 195px;
      margin-left: auto;
      img {
        width: 102px;
        height: 102px;
        display: block;
        margin: 0 auto;
      }
      p {
        font-size: 16px;
        font-weight: 400;
        color: #ffffff;
        letter-spacing: 1px;
        margin-top: 14px;
        text-align: center;
      }
    }
  }
  .baicaihuibottom_bottom {
    width: 100%;
    padding: 13px 40px;
    p {
      font-size: 12px;
      font-weight: 400;
      color: #ffffff;
      line-height: 20px;
      letter-spacing: 1px;
      text-align: center;
    }
  }
}
</style>
